import { Component, Input, OnInit } from '@angular/core';
import { Morphbox } from '@models/Sessions/Morphbox/Morphbox';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { ConfigService, IInputLengths } from '@services/config.service';
import { EventsService } from '@services/events.service';
import { SessionMorphboxRequestService } from '@services/sessions/session.morphbox.request.service';

@Component({
  selector: 'app-morphbox-new-row-modal',
  templateUrl: './new-row-modal.component.html',
  styleUrls: ['./new-row-modal.component.scss'],
})
export class NewMorphboxRowModalComponent implements OnInit {
  @Input() morphbox: Morphbox;
  @Input() session: Session;

  row = {
    text: '',
  };

  loading = false;

  inputLengths: IInputLengths;

  constructor(
    public activeModal: NgbActiveModal,
    private appConfig: ConfigService,
    private bus: BusService,
    private events: EventsService,
    private morphboxRequest: SessionMorphboxRequestService,
  ) {
    this.inputLengths = appConfig.inputLengths;
  }

  close() {
    this.loading = true;
    this.bus.publish(
      this.events.requested.action.session.morphbox.addRow,
      this.row,
      this.morphbox,
      this.session,
    );
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  addRowSuccess() {
    this.activeModal.close();
  }

  addRowFailure() {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.action.session.morphbox.addRow.success,
      this.addRowSuccess.bind(this),
    );
    this.bus.subscribe(
      this.events.received.action.session.morphbox.addRow.failure,
      this.addRowFailure.bind(this),
    );
  }
}
